import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-parent-teacher-meet',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class ParentTeacherMeetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
